import { render, staticRenderFns } from "./FeedbackModal.vue?vue&type=template&id=66f793fb&scoped=true"
import script from "./FeedbackModal.vue?vue&type=script&lang=ts"
export * from "./FeedbackModal.vue?vue&type=script&lang=ts"
import style0 from "./FeedbackModal.vue?vue&type=style&index=0&id=66f793fb&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f793fb",
  null
  
)

export default component.exports